<script setup lang="ts">
    import type { Schemas } from '#shopware';

    const props = defineProps<{
        product: Schemas['Product'];
        disableUnitPrice?: boolean;
    }>();

    const { t } = useI18n();

    const { product } = toRefs(props);

    const { unitPrice, hasListPrice, price } = useProductPrice(product);

    const beforePrice = computed<string>(() => useFormatPrice(price?.value?.listPrice?.price));

    const referencePrice = ref();
    if (product.value.calculatedCheapestPrice?.referencePrice?.price) {
        referencePrice.value = useFormatPrice(product.value.calculatedCheapestPrice?.referencePrice?.price);
    } else {
        referencePrice.value = useFormatPrice(product.value.calculatedPrice?.referencePrice?.price);
    }
</script>

<template>
    <div :id="product.id">
        <ClientOnly>
            <SharedPrice
                :value="unitPrice"
                price-size-medium
            >
                <template #afterPrice>
                    <div class="unit-price-wrapper">
                        <span v-if="!disableUnitPrice && product.calculatedPrice.referencePrice?.referenceUnit">
                            <ProductUnits
                                :product="product"
                                :show-content="false"
                                :shortened-unit-names="true"
                            />
                        </span>
                        <div v-if="hasListPrice">
                            <span class="after-price">{{ t('product.price.from') }}</span>
                            <span class="after-price --value">{{ beforePrice }}</span>
                        </div>
                    </div>
                </template>
            </SharedPrice>

            <template #fallback>
                <SharedPrice :value="product.calculatedPrice?.unitPrice" />
            </template>
        </ClientOnly>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/product-price/shared-listing-product-price.scss';
</style>
